import { render, staticRenderFns } from "./UsedBadge.vue?vue&type=template&id=b1904ef2&scoped=true&"
import script from "./UsedBadge.vue?vue&type=script&lang=js&"
export * from "./UsedBadge.vue?vue&type=script&lang=js&"
import style0 from "./UsedBadge.vue?vue&type=style&index=0&id=b1904ef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1904ef2",
  null
  
)

export default component.exports